"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyLocales = void 0;
const currency_enum_1 = require("./currency.enum");
const locale_enum_1 = require("./locale.enum");
exports.CurrencyLocales = {
    [currency_enum_1.CurrencyEnum.USD]: locale_enum_1.LocaleEnum.en_US,
    [currency_enum_1.CurrencyEnum.EUR]: locale_enum_1.LocaleEnum.de_DE,
    [currency_enum_1.CurrencyEnum.HUF]: locale_enum_1.LocaleEnum.hu_HU,
    [currency_enum_1.CurrencyEnum.ALL]: locale_enum_1.LocaleEnum.sq_AL,
    [currency_enum_1.CurrencyEnum.AMD]: locale_enum_1.LocaleEnum.hy_AM,
    [currency_enum_1.CurrencyEnum.AZN]: locale_enum_1.LocaleEnum.az_az,
    [currency_enum_1.CurrencyEnum.BYN]: locale_enum_1.LocaleEnum.be_BY,
    [currency_enum_1.CurrencyEnum.BAM]: locale_enum_1.LocaleEnum.bs_Latn_BA,
    [currency_enum_1.CurrencyEnum.BGN]: locale_enum_1.LocaleEnum.bg_BG,
    [currency_enum_1.CurrencyEnum.HRK]: locale_enum_1.LocaleEnum.hr_HR,
    [currency_enum_1.CurrencyEnum.GEL]: locale_enum_1.LocaleEnum.ka_GE,
    [currency_enum_1.CurrencyEnum.ISK]: locale_enum_1.LocaleEnum.is_IS,
    [currency_enum_1.CurrencyEnum.MDL]: locale_enum_1.LocaleEnum.ro_mo,
    [currency_enum_1.CurrencyEnum.RSD]: locale_enum_1.LocaleEnum.sr_sp,
    [currency_enum_1.CurrencyEnum.UAH]: locale_enum_1.LocaleEnum.uk_UA,
    [currency_enum_1.CurrencyEnum.JPY]: locale_enum_1.LocaleEnum.ja_JP,
    [currency_enum_1.CurrencyEnum.GBP]: locale_enum_1.LocaleEnum.en_GB,
    [currency_enum_1.CurrencyEnum.AUD]: locale_enum_1.LocaleEnum.en_AU,
    [currency_enum_1.CurrencyEnum.CAD]: locale_enum_1.LocaleEnum.en_CA,
    [currency_enum_1.CurrencyEnum.CHF]: locale_enum_1.LocaleEnum.de_CH,
    [currency_enum_1.CurrencyEnum.CNY]: locale_enum_1.LocaleEnum.zh_CN,
    [currency_enum_1.CurrencyEnum.HKD]: locale_enum_1.LocaleEnum.zh_HK,
    [currency_enum_1.CurrencyEnum.NZD]: locale_enum_1.LocaleEnum.en_NZ,
    [currency_enum_1.CurrencyEnum.SEK]: locale_enum_1.LocaleEnum.sv_SE,
    [currency_enum_1.CurrencyEnum.KRW]: locale_enum_1.LocaleEnum.ko_KR,
    [currency_enum_1.CurrencyEnum.SGD]: locale_enum_1.LocaleEnum.en_SG,
    [currency_enum_1.CurrencyEnum.NOK]: locale_enum_1.LocaleEnum.nb_NO,
    [currency_enum_1.CurrencyEnum.MXN]: locale_enum_1.LocaleEnum.es_MX,
    [currency_enum_1.CurrencyEnum.INR]: locale_enum_1.LocaleEnum.hi_IN,
    [currency_enum_1.CurrencyEnum.RUB]: locale_enum_1.LocaleEnum.ru_RU,
    [currency_enum_1.CurrencyEnum.ZAR]: locale_enum_1.LocaleEnum.en_ZA,
    [currency_enum_1.CurrencyEnum.TRY]: locale_enum_1.LocaleEnum.tr_TR,
    [currency_enum_1.CurrencyEnum.BRL]: locale_enum_1.LocaleEnum.pt_BR,
    [currency_enum_1.CurrencyEnum.TWD]: locale_enum_1.LocaleEnum.zh_TW,
    [currency_enum_1.CurrencyEnum.DKK]: locale_enum_1.LocaleEnum.da_DK,
    [currency_enum_1.CurrencyEnum.PLN]: locale_enum_1.LocaleEnum.pl_PL,
    [currency_enum_1.CurrencyEnum.THB]: locale_enum_1.LocaleEnum.th_TH,
    [currency_enum_1.CurrencyEnum.IDR]: locale_enum_1.LocaleEnum.id_ID,
    [currency_enum_1.CurrencyEnum.CZK]: locale_enum_1.LocaleEnum.cs_CZ,
    [currency_enum_1.CurrencyEnum.ILS]: locale_enum_1.LocaleEnum.he_IL,
    [currency_enum_1.CurrencyEnum.CLP]: locale_enum_1.LocaleEnum.es_CL,
    [currency_enum_1.CurrencyEnum.PHP]: locale_enum_1.LocaleEnum.en_PH,
    [currency_enum_1.CurrencyEnum.AED]: locale_enum_1.LocaleEnum.ar_AE,
    [currency_enum_1.CurrencyEnum.COP]: locale_enum_1.LocaleEnum.es_CO,
    [currency_enum_1.CurrencyEnum.SAR]: locale_enum_1.LocaleEnum.ar_SA,
    [currency_enum_1.CurrencyEnum.MYR]: locale_enum_1.LocaleEnum.ms_MY,
    [currency_enum_1.CurrencyEnum.RON]: locale_enum_1.LocaleEnum.ro_RO,
    [currency_enum_1.CurrencyEnum.UGX]: locale_enum_1.LocaleEnum.xh_ZA,
    [currency_enum_1.CurrencyEnum.KES]: locale_enum_1.LocaleEnum.en_KE,
    [currency_enum_1.CurrencyEnum.NGN]: locale_enum_1.LocaleEnum.en_NG,
    [currency_enum_1.CurrencyEnum.ARS]: locale_enum_1.LocaleEnum.es_AR,
};
